<template>
  <v-card color="grey lighten-3 elevation-0">
    <v-card-text class="py-1">
      <v-row class="align-center">
        <!--<v-col class="flex-grow-0 flex-shrink-1 py-0">
          <v-tooltip top>
            <template v-slot:activator="{on}">
              <v-icon v-on="on" class="dragIcon">mdi-drag</v-icon>
            </template>
            <span>Drag & Drop</span>
          </v-tooltip>
        </v-col>-->
        <v-col class="flex-grow-0 flex-shrink-1">
          <v-tooltip v-if="debt.type == 'mortgage'" top>
            <template v-slot:activator="{on}">
              <v-icon v-on="on">mdi-home</v-icon>
            </template>
            <span>Mortgage</span>
          </v-tooltip>
          <v-tooltip v-if="debt.type == 'credit'" top>
            <template v-slot:activator="{on}">
              <v-icon v-on="on">mdi-credit-card</v-icon>
            </template>
            <span>Credit Card</span>
          </v-tooltip>
          <v-tooltip v-if="debt.type == 'auto'" top>
            <template v-slot:activator="{on}">
              <v-icon v-on="on">mdi-car</v-icon>
            </template>
            <span>Auto Loan</span>
          </v-tooltip>
          <v-tooltip v-if="debt.type == 'other'" top>
            <template v-slot:activator="{on}">
              <v-icon v-on="on">mdi-bank</v-icon>
            </template>
            <span>Other Loan</span>
          </v-tooltip>
        </v-col>
        <v-col class="debtName py-0">
          <div class="overline grey--text">Name</div>
          <div>{{ debt.name }}</div>
        </v-col>
        <v-col class="py-0">
          <div class="overline grey--text">Balance</div>
          <div>{{ debt.balance | currencyRounded }}</div>
        </v-col>
        <v-col class="py-0">
          <div class="overline grey--text">Interest Rate</div>
          <div>{{ debt.interest_rate }}%</div>
        </v-col>
        <v-col class="py-0">
          <div class="overline grey--text">Minimum Payment</div>
          <div>{{ debt.minimum_payment | currencyRounded }}</div>
        </v-col>
        <v-col class="py-0">
          <div class="overline grey--text">Payoff</div>
          <div>{{ $moment(debt.end_date).format('L') }}</div>
        </v-col>
        <v-col class="flex-grow-0 flex-shrink-1 py-0 pr-0" v-if="editable">
          <v-btn icon @click="$emit('on-edit')"><v-icon>mdi-pencil</v-icon></v-btn>
        </v-col>
        <v-col class="flex-grow-0 flex-shrink-1 py-0 pl-0" v-if="deletable">
          <v-btn icon @click="$emit('on-delete')"><v-icon>mdi-delete</v-icon></v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'DebtContainer',
  props: {
    debt: {
      type: Object,
      required: true
    },
    editable: Boolean,
    deletable: Boolean
  }
}
</script>